module.exports = __webpack_public_path__ + "img/Sound Icon - white.95d9f1d0.svg";